import {ChangeDetectionStrategy, Component, HostBinding, TrackByFunction, ViewEncapsulation} from '@angular/core';
import {FormatedError, KEY_HAND_ERROR_SERVER} from "@core/libs";

import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {TranslocoModule} from "@jsverse/transloco";

export abstract class BaseValidationMessagesComponent {
  errors: FormatedError[] = [];
  classes = '';

  trackByFn: TrackByFunction<FormatedError> = (_, item) => item.key;
}


@Component({
  selector: 'app-validation-messages',
  template: `
 @for (error of errors.slice(0, 1); track trackByFn($index, error)) {
 @if (error.key == keyHand) {
 <i [class]="cls" ngbTooltip="{{ error.message }}"></i>
 }
 @if (error.key != keyHand) {
 <i [class]="cls" ngbTooltip="{{ error.message | transloco }}"></i>
 }
 }
 `,
  styles: [`
 .form-control.is-invalid, .was-validated .form-control:invalid {
 background: transparent;
 }
 `],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    TranslocoModule,
    NgbTooltip
  ]
})
export class DefaultValidationMessagesComponent extends BaseValidationMessagesComponent {
  cls = 'ph ph-warning-circle text-danger cursor-pointer';
  keyHand = KEY_HAND_ERROR_SERVER;
  @HostBinding('class') override classes = '';
  protected readonly KEY_HAND_ERROR_SERVER = KEY_HAND_ERROR_SERVER;
}
